<template>
  <div>
    <el-row>
      <el-col style="margin-top:18px">
        <el-button size="medium" @click="addProduct">新增赠品入库</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="product_table" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="产品编码" prop="PRODUCT_CODE" min-width="100"></el-table-column>
          <el-table-column label="产品名称" prop="NAME" min-width="100"></el-table-column>
          <el-table-column label="单位" prop="TYPE_UNIT" min-width="30"></el-table-column>
          <el-table-column label="入库数量" prop="PRODUCT_COUNT" width="100">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.PRODUCT_COUNT" @blur="saveProperty()" @change="setProductNumber(scope.row)" placeholder="数量"
                clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column label="生产日期" width="160">
            <template slot-scope="scope">
              <el-date-picker style="width:130px" v-model="scope.row.PRODUCTION_DATE" type="date" @blur="saveProperty()" placeholder="生产日期"
                value-format="yyyy-MM-dd" :clearable="true" size="small"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column label="保质期" min-width="50">
            <template slot-scope="scope">
              <span>{{ scope.row.QGP + QGP_TIME_TYPE[scope.row.QGP_TIME_TYPE] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="库位">
            <template slot-scope="scope">
              <el-select v-model="scope.row.LOCATION_ID" placeholder="请选择">
                <el-option v-for="item in positionList" :key="item.ID" :label="item.CODE" :value="item.ID">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="deleteProduct(scope.row, scope.index)" icon="el-icon-close"
                style="color:#F56C6C">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog title="新增赠品入库" center :visible.sync="addFormVisible" width="50%" :close-on-click-modal="false">
      <el-form size="small" :inline="true" class="demo-form-inline" :model="searchForm" ref="searchForm" @submit.native.prevent>
        <el-form-item label="产品编码：">
          <el-input placeholder="产品编码" @keyup.enter.native="seachFun()" clearable v-model="searchForm.code" :value="searchForm.code"></el-input>
        </el-form-item>
        <el-form-item label="产品名称：">
          <el-input placeholder="产品名称" @keyup.enter.native="seachFun()" clearable v-model="searchForm.name" :value="searchForm.name"></el-input>
        </el-form-item>
        <el-button size="small" @click="queryTable()">搜索</el-button>
      </el-form>
      <el-row>
        <el-col :span="24">
          <el-table stripe border :data="mainList" style="width: 100%" max-height="350">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="编码" prop="PRODUCT_CODE" width="120"></el-table-column>
            <el-table-column label="名称" prop="NAME" min-width="100"></el-table-column>
            <el-table-column label="单位" prop="TYPE_UNIT" width="50"></el-table-column>
            <el-table-column label="入库数量" prop="product_count" width="130">
              <template slot-scope="scope">
                <el-input v-model="scope.row.product_count" @change="setNumber(scope.row)" clearable>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button size="small" @click="addInstock(scope.row)" v-preventReClick>加入</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: right">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
            layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addFormVisible = false">取 消</el-button>
        <el-button size="small" @click="addFormVisible = false" :loading="loading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="赠品入库" center :visible.sync="storageDialog" width="450px">
      <el-form :model="storageForm" ref="storageForm" size="medium" :inline="true">
        <el-form-item label="订单日期：" :label-width="formLableWidth">
          <el-date-picker v-model="storageForm.SEND_DAY" clearable type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="供应商：" :label-width="formLableWidth">
          <el-select filterable v-model="storageForm.SUPPLIER_ID" placeholder="请选择供应商" :clearable="true">
            <el-option v-for="item in supplierList" :key="item.SUPPLIER_ID" :label="item.NAME" :value="item.SUPPLIER_ID"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="storageDialog = false">取 消</el-button>
        <el-button size="small" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
    <el-row>
      <el-col>
        <el-button size="small" @click="Storage" style="float:right;margin-top: 20px">全部确认</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { haveGYSFun } from 'api/shopOrderManage';
import { addGiftsInstockConfirm, queryPosition } from '@/assets/api/warehouseManager';
import { queryUseSKU } from '@/assets/api/skuManage';
import date from '@/assets/common/date';
import util from '@/assets/common/util';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      positionList: [],
      loading: false,
      tableData: [],
      addFormVisible: false,
      searchForm: {},
      mainList: [],
      product_table: [],
      timer: null,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      totalCount: 0,
      currentPage: 1,
      QGP_TIME_TYPE: ['', '年', '季', '个月', '天', '小时'],
      supplierList: [],
      storageDialog: false,
      storageForm: {
        SEND_DAY: date(new Date(), '%F'),
      },
      formLableWidth: '120px',
    };
  },
  created() {
    this.queryAllSupplier();
    this.queryData();
    const list = JSON.parse(sessionStorage.getItem('gifts_instock'));
    if (list) {
      this.product_table = list;
    }
  },
  methods: {
    // 拉取库位
    queryData() {
      queryPosition().then((result) => {
        if (result.length !== 0) {
          this.positionList = result;
        } else {
          this.tableData = [];
          this.$message.show({ text: '拉取库位失败', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 拉取供应商
    queryAllSupplier() {
      const params = {};
      haveGYSFun(params).then((result) => {
        if (result.length !== 0) {
          this.supplierList = result[0].list;
        } else {
          this.supplierList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    addProduct() {
      this.addFormVisible = true;
    },
    // 拉取
    queryTable() {
      if (!validation.产品编码验证(this.searchForm.code)) {
        this.$message.show({ text: '产品编码只能输入数字', type: 'warning' });
        return false;
      }
      const params = {
        STATUS: 1, // 启用的 SKU 才能搜到
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.code) {
        params.PRODUCT_CODE = parseInt(this.searchForm.code);
      }
      if (this.searchForm.name) {
        params.PRODUCT_NAME = this.searchForm.name;
      }
      queryUseSKU(params).then((result) => {
        if (result[0] && result[0].list.length) {
          this.tableData = result[0].list;
          this.mainList = result[0].list;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.$message.show({ text: '暂无数据', type: 'success' });
          this.mainList = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    setProductNumber(row) {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(row.PRODUCT_COUNT)) {
        this.$message.show({ text: '请输入正数订购数量', type: 'warning' });
        row.PRODUCT_COUNT = '';
        return false;
      }
      if (!util.JudgmentUnit(row.TYPE_UNIT)) { // 如果不是
        const beInter = (row.PRODUCT_COUNT % 1 === 0);
        if (beInter == false) {
          this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'warning' });
          row.PRODUCT_COUNT = '';
          return false;
        }
      }
      return true;
    },
    setNumber(row) {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(row.product_count)) {
        this.$message.show({ text: '请输入正数订购数量', type: 'warning' });
        return false;
      }
      if (row.product_count == 0) {
        this.$message.show({ text: '请输入正数订购数量', type: 'warning' });
        return false;
      }
      if (!util.JudgmentUnit(row.TYPE_UNIT)) { // 如果不是
        const beInter = (row.product_count % 1 === 0);
        if (beInter == false) {
          this.$message.show({ text: '单位不是KG的，只能输入整数', type: 'warning' });
          return false;
        }
      }
      return true;
    },
    addInstock(row) {
      if (this.setNumber(row)) {
        const product = {
          NAME: row.NAME,
          TYPE_UNIT: row.TYPE_UNIT,
          PRODUCT_CODE: row.PRODUCT_CODE,
          PRODUCT_COUNT: row.product_count,
          PRODUCTION_DATE: date(new Date(), '%F'),
          QGP: row.QGP,
          QGP_TIME_TYPE: row.QGP_TIME_TYPE,
          index: this.product_table.length,
        };
        this.product_table.push(product);
        sessionStorage.setItem('gifts_instock', JSON.stringify(this.product_table));
      }
    },
    deleteProduct(row) {
      this.product_table.forEach((item, index) => {
        if (item.index == row.index) {
          this.product_table.splice(index, 1);
        }
      });
      sessionStorage.setItem('gifts_instock', JSON.stringify(this.product_table));
    },
    Storage() {
      if (this.product_table.length == 0) {
        this.$message.show({ text: '暂无入库产品，请先添加入库产品', type: 'warning' });
        return false;
      }
      this.storageDialog = true;
    },
    submit() {
      const arr = this.product_table.map((item) => {
        const params = {
          PRODUCT_CODE: item.PRODUCT_CODE,
          PRODUCTION_DATE: item.PRODUCTION_DATE,
          PRODUCT_COUNT: item.PRODUCT_COUNT,
        };
        if (item.LOCATION_ID) {
          params.LOCATION_ID = item.LOCATION_ID;
        }
        return params;
      });
      let numFlag = 1;
      arr.forEach((element) => {
        if (element.PRODUCT_COUNT == 0 || !element.PRODUCT_COUNT) {
          numFlag = 0;
        }
      });
      if (numFlag == 0) {
        this.$message.show({ text: '请输入正确入库数量', type: 'warning' });
        return false;
      }
      if (!this.storageForm.SUPPLIER_ID || !this.storageForm.SEND_DAY) {
        this.$message.show({ text: '订单日期和供应商为必填项', type: 'warning' });
        return false;
      }
      const params = {
        PRODUCT_ARRAY: arr,
        SUPPLIER_ID: this.storageForm.SUPPLIER_ID,
        SEND_DAY: this.storageForm.SEND_DAY,
      };
      addGiftsInstockConfirm(params).then((result) => {
        this.$message.show({ text: '入库成功', type: 'success' });
        sessionStorage.removeItem('gifts_instock');
        this.product_table.splice(0);
        this.storageDialog = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.storageDialog = false;
      });
    },
    // 防抖
    saveProperty() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        sessionStorage.setItem('gifts_instock', JSON.stringify(this.product_table)).map((item) => { });
        this.timer = null;
      }, 500);
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryTable();
    },
  },
};
</script>
<style scope>
.inline-input {
  width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/giftsInstock.vue